import React, { useState } from 'react';
import logo from '../assets/logo.png'; // Asegúrate que esta ruta es correcta

const Navbar = ({ navigateTo }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigate = (section) => {
    navigateTo(section);
    setMenuOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-md backdrop-blur-sm bg-opacity-80">
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src={logo}
            alt="Ziel Consulting Logo"
            className="h-12 transition-transform duration-300 hover:scale-105"
          />
        </div>
        
        {/* 👇 MENÚ DE ESCRITORIO 👇 */}
        {/* Nota: Agregué "items-center" aquí para que el botón nuevo quede bien alineado verticalmente con el texto */}
        <div className="hidden md:flex space-x-8 items-center">
          <button onClick={() => handleNavigate('inicio')} className="text-black hover:text-[#199ca5] relative group transition-colors duration-300">
            Inicio
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#199ca5] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
          </button>
          <button onClick={() => handleNavigate('nosotros')} className="text-black hover:text-[#199ca5] relative group transition-colors duration-300">
            Nosotros
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#199ca5] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
          </button>
          <button onClick={() => handleNavigate('servicios')} className="text-black hover:text-[#199ca5] relative group transition-colors duration-300">
            Servicios
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#199ca5] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
          </button>
          <button onClick={() => handleNavigate('contacto')} className="text-black hover:text-[#199ca5] relative group transition-colors duration-300">
            Contacto
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#199ca5] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
          </button>
          <a href="/blog.html" className="text-black hover:text-[#199ca5] relative group transition-colors duration-300">
            Blog
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#199ca5] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
          </a>
          
          {/* 👇 NUEVO BOTÓN AUTODIAGNÓSTICO (ESCRITORIO) 👇 */}
          <a 
            href="https://www.zielconsulting.com.co/autodiagnosticos" 
            className="bg-[#199ca5] text-white px-5 py-2 rounded-md font-semibold hover:bg-opacity-90 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5"
          >
            Haz tu diagnóstico
          </a>
        </div>

        {/* BOTÓN DE MENÚ HAMBURGUESA (MÓVIL) */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden focus:outline-none p-2 rounded-md hover:bg-gray-100 transition-colors duration-200">
          <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* 👇 MENÚ MÓVIL 👇 */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-md">
          <div className="flex flex-col px-6 pb-4 space-y-4">
            <button onClick={() => handleNavigate('inicio')} className="text-left text-black hover:text-[#199ca5] transition-colors duration-300">
              Inicio
            </button>
            <button onClick={() => handleNavigate('nosotros')} className="text-left text-black hover:text-[#199ca5] transition-colors duration-300">
              Nosotros
            </button>
            <button onClick={() => handleNavigate('servicios')} className="text-left text-black hover:text-[#199ca5] transition-colors duration-300">
              Servicios
            </button>
            <button onClick={() => handleNavigate('contacto')} className="text-left text-black hover:text-[#199ca5] transition-colors duration-300">
              Contacto
            </button>
            <a href="/blog.html" className="text-left text-black hover:text-[#199ca5] transition-colors duration-300">
              Blog
            </a>
            
            {/* 👇 NUEVO BOTÓN AUTODIAGNÓSTICO (MÓVIL) 👇 */}
            <a 
              href="https://www.zielconsulting.com.co/autodiagnosticos" 
              className="text-center bg-[#199ca5] text-white px-4 py-2 rounded-md font-semibold hover:bg-opacity-90 transition-colors duration-300 mt-2"
            >
              Haz tu diagnóstico
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
